import {
  OrderByEnum, OrderTypeEnum, StaffFullTimeDetailTypes, StaffFullTimeItemTypes,
  StaffFullTimeParamsTypes
} from './types';

import axiosInstance from 'common/services/common/instance';

export const getAllStaffFulltimeService = async (params: BaseFilterParams
  & {
    _department?: string,
    _exceptStaffIds?: string
    _exceptDepartment?: string
    _orderBy?: OrderByEnum,
    _orderType?: OrderTypeEnum
  }): Promise<APIPaginationResponse<StaffFullTimeItemTypes[]>> => {
  const res = await axiosInstance.get('staff-full-time', { params });
  return res.data;
};

export const createStaffFulltimeService = async (
  params: StaffFullTimeParamsTypes
) => {
  const res = await axiosInstance.post('staff-full-time', params);
  return res.data;
};

export const deleteStaffFulltimeService = async (
  ids: number[],
): Promise<void> => {
  await axiosInstance.delete('staff-full-time', { data: { ids } });
};

export const getStaffFulltimeByIdService = async (
  id: number,
): Promise<StaffFullTimeDetailTypes> => {
  const res = await axiosInstance.get(`staff-full-time/${id}`);
  return res.data.data;
};

export const updateStaffFullnameService = async (
  params: { id: number, data: StaffFullTimeParamsTypes },
): Promise<void> => {
  await axiosInstance.put(`staff-full-time/${params.id}`, params.data);
};
